/**
 * @fileoverview Spinner pequeño y silencioso, usado en botones y
 * estados de carga ligera.
 */

import { Loader2 } from "lucide-react";

/**
 * @param {{ size?: number, className?: string, label?: string }} props
 */
export function LoadingSpinner({ size = 20, className = "", label = "Cargando" }) {
    return (
        <span
            role="status"
            aria-label={label}
            className={`inline-flex items-center justify-center ${className}`}
            data-testid="loading-spinner"
        >
            <Loader2 size={size} className="animate-spin" />
            <span className="sr-only">{label}</span>
        </span>
    );
}
